export const DEFAULT_VEHICLE_COLOR_HEX = '#cccccc';

const VEHICLE_COLOR_MAP: Record<string, string> = {
  black: '#000000',
  white: '#ffffff',
  silver: '#c0c0c0',
  gray: '#808080',
  grey: '#808080',
  charcoal: '#36454f',
  red: '#ff0000',
  maroon: '#800000',
  burgundy: '#800020',
  blue: '#0000ff',
  navy: '#000080',
  indigo: '#4b0082',
  teal: '#008080',
  turquoise: '#40e0d0',
  green: '#008000',
  lime: '#00ff00',
  olive: '#808000',
  yellow: '#ffff00',
  gold: '#ffd700',
  orange: '#ffa500',
  brown: '#8b4513',
  tan: '#d2b48c',
  beige: '#f5f5dc',
  cream: '#fffdd0',
  ivory: '#fffff0',
  champagne: '#f7e7ce',
  copper: '#b87333',
  bronze: '#cd7f32',
  purple: '#800080',
  lavender: '#e6e6fa',
  pink: '#FF69B4',
};

const SORTED_COLOR_NAMES = Object.keys(VEHICLE_COLOR_MAP).sort(
  (left, right) => right.length - left.length
);

export function resolveVehicleColorHex(vehicleColor?: string | null): string {
  const normalizedColor = vehicleColor?.trim().toLowerCase();

  if (!normalizedColor) {
    return DEFAULT_VEHICLE_COLOR_HEX;
  }

  const matchedColorName = SORTED_COLOR_NAMES.find((colorName) =>
    normalizedColor.includes(colorName)
  );

  if (!matchedColorName) {
    return DEFAULT_VEHICLE_COLOR_HEX;
  }

  return VEHICLE_COLOR_MAP[matchedColorName];
}
